import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, SelectField, Text } from "@cinch-labs/design-system";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useEffect, useState } from "react";
import { createTrackers } from "./tracking";
import styles from "./filters.module.css";
import { Datadog } from "@cinch-nx/landing-ui-shared";
import { datadogRum } from "@datadog/browser-rum";
import { MONTHLY_PRICE, TOTAL_PRICE, updateModelOptions, getSearchButtonText, onMakeSelected, onModelSelected, onSubmit, updateSearchButtonLabel, updateStockLevels } from "./handlers";
import { decorateOptions } from "../utils/decorate-options";
import { Price } from "./price/price";
var Actions = Datadog.Actions, Context = Datadog.Context;
export var Filters = function(param) {
    var totalStock = param.totalStock, makes = param.makes, starRatingLabel = param.starRatingLabel, starRating = param.starRating, numberOfReviews = param.numberOfReviews, section = param.section;
    var trackEvent = useAnalytics().trackEvent;
    var ref = useState(MONTHLY_PRICE), radioChecked = ref[0], setRadioChecked = ref[1];
    var ref1 = useState(0), maxTotalPrice = ref1[0], setMaxTotalPrice = ref1[1];
    var ref2 = useState(), selectedMake = ref2[0], setSelectedMake = ref2[1];
    var ref3 = useState(), selectedModel = ref3[0], setSelectedModel = ref3[1];
    var ref4 = useState(decorateOptions(makes.map(function(make) {
        return {
            label: "".concat(make.name, " (").concat(make.stock, ")"),
            value: make.name,
            count: "".concat(make.stock)
        };
    }), totalStock)), makeOptions = ref4[0], setMakeOptions = ref4[1];
    var ref5 = useState(getSearchButtonText(totalStock)), searchButtonText = ref5[0], setSearchButtonText = ref5[1];
    var ref6 = useState([]), modelOptions = ref6[0], setModelOptions = ref6[1];
    var ref7 = useState({}), priceBucket = ref7[0], setPriceBucket = ref7[1];
    var ref8 = useState({}), monthlyPriceBucket = ref8[0], setMonthlyPriceBucket = ref8[1];
    var ref9 = createTrackers(trackEvent), handleOnChangeTracking = ref9.onChange, handleOnSubmitTracking = ref9.onSubmit;
    var handleTrackEvent = function() {
        datadogRum.addAction(Actions.CLICK_HMC_LINK_IN_FILTERS_SECTION, {
            service: Context.HERO_HMC,
            squad: Context.SQUAD,
            page: "/",
            category: "hero",
            label: "help-me-choose-click - inside find a car",
            value: "help-me-choose-click"
        });
        trackEvent({
            eventName: "Help me choose inside find a car - click",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "hero",
                    label: "inside find a car",
                    action: "Help me choose"
                }
            }
        });
    };
    useEffect(function() {
        updateSearchButtonLabel({
            selectedMake: selectedMake,
            selectedModel: selectedModel,
            radioChecked: radioChecked,
            maxTotalPrice: maxTotalPrice,
            setButtonText: setSearchButtonText
        }).catch(function(error) {
            setSearchButtonText(getSearchButtonText(totalStock));
            console.error("Unable to update search button label cause:", error);
            datadogRum.addError(error);
        });
    }, [
        selectedMake,
        selectedModel,
        radioChecked,
        maxTotalPrice
    ]);
    useEffect(function() {
        updateStockLevels({
            selectedMake: selectedMake,
            selectedModel: selectedModel,
            maxTotalPrice: maxTotalPrice,
            radioChecked: radioChecked,
            totalStock: totalStock,
            setModelOptions: setModelOptions,
            setMakeOptions: setMakeOptions,
            setPriceBucket: setPriceBucket,
            setMonthlyPriceBucket: setMonthlyPriceBucket
        }).catch(function(error) {
            setMakeOptions(decorateOptions(makes.map(function(make) {
                return {
                    label: "".concat(make.name, " (").concat(make.stock, ")"),
                    value: make.name,
                    count: "".concat(make.stock)
                };
            }), totalStock));
            setModelOptions([]);
            console.error("Unable to stock levels:", error);
            datadogRum.addError(error);
        });
    }, [
        selectedMake,
        selectedModel,
        radioChecked,
        maxTotalPrice
    ]);
    useEffect(function() {
        updateModelOptions({
            selectedMake: selectedMake,
            selectedModel: selectedModel,
            makes: makes,
            setModelOptions: setModelOptions
        });
    }, [
        selectedMake,
        selectedModel,
        makes
    ]);
    useEffect(function() {
        if (!selectedMake && selectedMake !== "") {
            setSelectedMake("");
        }
    }, [
        selectedMake
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["container"],
        children: [
            /*#__PURE__*/ _jsx(Text, {
                element: "h1",
                className: styles["heading"],
                children: "Buy used cars online"
            }),
            /*#__PURE__*/ _jsxs("form", {
                className: styles["form"],
                onSubmit: function(event) {
                    return onSubmit({
                        handleOnSubmitTracking: handleOnSubmitTracking,
                        maxTotalPrice: maxTotalPrice,
                        radioChecked: radioChecked,
                        selectedMake: selectedMake,
                        selectedModel: selectedModel,
                        event: event,
                        section: section
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx(SelectField, {
                        label: "Select make",
                        labelHidden: true,
                        id: "make",
                        name: "make",
                        "data-testid": "make-select",
                        options: makeOptions,
                        placeholder: "Select make",
                        placeholderValue: "Any",
                        value: selectedMake,
                        onChange: function(event) {
                            return onMakeSelected({
                                setSelectedMake: setSelectedMake,
                                setSelectedModel: setSelectedModel,
                                setMakeOptions: setMakeOptions,
                                handleOnChangeTracking: handleOnChangeTracking,
                                event: event,
                                section: section
                            });
                        },
                        error: {
                            show: false,
                            classNames: {
                                container: styles["errorBox"]
                            }
                        }
                    }),
                    /*#__PURE__*/ _jsx(SelectField, {
                        label: "Select model",
                        labelHidden: true,
                        id: "model",
                        name: "model",
                        "data-testid": "model-select",
                        options: modelOptions,
                        placeholder: "Select model",
                        placeholderValue: "Any",
                        value: selectedModel,
                        onChange: function(event) {
                            return onModelSelected({
                                setSelectedModel: setSelectedModel,
                                handleOnChangeTracking: handleOnChangeTracking,
                                event: event,
                                section: section
                            });
                        },
                        disabled: !selectedMake || selectedMake.toLocaleLowerCase() === "any",
                        error: {
                            show: false,
                            classNames: {
                                container: styles["errorBox"]
                            }
                        }
                    }),
                    /*#__PURE__*/ _jsxs("fieldset", {
                        className: styles["radioGroup"],
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles["radioInputContainer"],
                                children: /*#__PURE__*/ _jsxs("label", {
                                    htmlFor: MONTHLY_PRICE,
                                    className: styles["priceLabel"],
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            type: "radio",
                                            id: MONTHLY_PRICE,
                                            name: MONTHLY_PRICE,
                                            checked: radioChecked === MONTHLY_PRICE,
                                            onChange: function() {
                                                setRadioChecked(MONTHLY_PRICE);
                                                setMaxTotalPrice(0);
                                                handleOnChangeTracking({
                                                    trackEventLabel: "monthly price",
                                                    trackEventAction: "button",
                                                    value: "".concat(MONTHLY_PRICE, " checked"),
                                                    datadogActionName: Actions.CLICK_MONTHLY_PRICE_RADIO
                                                });
                                            }
                                        }),
                                        "Monthly price"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles["radioInputContainer"],
                                children: /*#__PURE__*/ _jsxs("label", {
                                    htmlFor: TOTAL_PRICE,
                                    className: styles["priceLabel"],
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            type: "radio",
                                            id: TOTAL_PRICE,
                                            name: TOTAL_PRICE,
                                            checked: radioChecked === TOTAL_PRICE,
                                            onChange: function() {
                                                setRadioChecked(TOTAL_PRICE);
                                                setMaxTotalPrice(0);
                                                handleOnChangeTracking({
                                                    trackEventLabel: "total price",
                                                    trackEventAction: "button",
                                                    value: "".concat(TOTAL_PRICE, " checked"),
                                                    datadogActionName: Actions.CLICK_TOTAL_PRICE_RADIO
                                                });
                                            }
                                        }),
                                        "Total price"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Price, {
                        radioChecked: radioChecked,
                        handleOnChangeTracking: handleOnChangeTracking,
                        maxTotalPrice: maxTotalPrice,
                        setMaxTotalPrice: setMaxTotalPrice,
                        priceBucket: priceBucket,
                        monthlyPriceBucket: monthlyPriceBucket
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles["buttonContainer"],
                        children: /*#__PURE__*/ _jsx(Primary, {
                            type: "submit",
                            classNames: {
                                button: styles["button"]
                            },
                            "data-testid": "searchButton",
                            isFullWidth: true,
                            children: searchButtonText
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["helpMeChoose"],
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "Not sure where to start?"
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "Try our ",
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://www.cinch.co.uk/help-me-choose/most-important",
                                        className: styles["link"],
                                        onClick: function() {
                                            return handleTrackEvent();
                                        },
                                        children: "Help Me Choose tool"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
